var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#2B61D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1042 14.5474L9 15.1875L6.62737 13.8139L7.70456 13.1901L7.73156 13.1743L7.77262 13.1979L10.1042 14.5474ZM14.3438 5.90625V7.19381L12.0082 5.84212L11.3749 5.47538L10.7415 5.84212L7.77262 7.56056L7.13925 7.92731V8.68556L5.99737 8.02406L5.36344 7.65731L4.73006 8.02406L3.65625 8.64619V5.90625L9 2.8125L14.3438 5.90625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3438 8.66072V12.0982L11.3749 13.8172L11.3709 13.8149L8.40656 12.0982V8.66129L11.3749 6.94116L14.3438 8.66072ZM7.07119 10.1131V12.0897L5.364 13.078L3.65625 12.0897V10.1131L5.364 9.12422L7.07119 10.1131Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32534"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlux);
export default __webpack_public_path__ + "static/media/flux.4965351ee9c744d714d98f275fc5ef11.svg";
export { ForwardRef as ReactComponent };